"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Renders App in a wrapper that facilitates easier updates to top level props.
 */
var AppRenderer = /*#__PURE__*/function () {
  /**
   * @param {Object} initialState - props to render with App
   * @param {HTMLElement} element - HTML Element in DOM to render app to.
   * @returns {undefined}
   */
  function AppRenderer() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var element = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, AppRenderer);

    if (!element) {
      throw new Error('You must provide an DOM Element to mount into.');
    }

    this.state = initialState;
    this.element = element;
    this.providerRef = /*#__PURE__*/_react["default"].createRef();
    this.render();
    this.handleOnCommentsApiUpdate = this.handleOnCommentsApiUpdate.bind(this);
  }
  /**
   * Set new state and render the app. This will spread with existing state.
   * @param {Object} newState - new state to update
   * @returns {undefined}
   */


  _createClass(AppRenderer, [{
    key: "setState",
    value: function setState(newState) {
      this.state = _objectSpread(_objectSpread({}, this.state), newState);
      this.render();
    }
    /**
     * Handles comments API updating
     * @returns {undefined}
     */

  }, {
    key: "handleOnCommentsApiUpdate",
    value: function handleOnCommentsApiUpdate() {
      this.render();
    }
    /**
     * Getter shortcut for ref of CommentsProvider instance
     * @returns {Object} - CommentsProvider instance
     */

  }, {
    key: "render",

    /**
     * Render the app with set state.
     * @returns {undefined}
     */
    value: function render() {
      var _this = this;

      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('./components/App'));
      }).then(function (AppFull) {
        var App = AppFull["default"];

        _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(App, _extends({}, _this.state, {
          ref: _this.providerRef,
          onCommentsApiUpdate: _this.handleOnCommentsApiUpdate
        })), _this.element);
      });
    }
  }, {
    key: "ref",
    get: function get() {
      return this.providerRef.current;
    }
  }]);

  return AppRenderer;
}();

var _default = AppRenderer;
exports["default"] = _default;